import type { FetchBaseQueryArgs } from '@reduxjs/toolkit/dist/query/fetchBaseQuery'
import { fetchBaseQuery } from '@reduxjs/toolkit/query'

export const BASE_URL = 'https://api.stp.looptech.az/api'

const baseQueryConfig: FetchBaseQueryArgs = {
  baseUrl: BASE_URL,
  headers: {
    'X-AuthMode': 'JWT',
  },
  credentials: 'include',
}

const baseQuery = fetchBaseQuery(baseQueryConfig)

export default baseQuery
